import React from "react";
import { components } from "react-select";
import { ArrowDown2 } from "iconsax-react";

export const customStyles = {
  control: (styles) => ({
    ...styles,
    background: "var(--white-color)",
    border: "0.5px solid var(--tertiary-color)",
    fontSize: "var(--font-size-xs)",
    borderRadius: 6,
    height: 40,
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "100%",
  }),
  SingleValue: () => ({
    maxWidth: "90%",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected && "var(--blue-color-light)",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "var(--text-color-muted)",
    fontSize: "var(--font-size-xs)",
    outline: 0,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    minWidth: 10,
    justifyContent: "center",
  }),
};
export const DropdownIndicatorComponent = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDown2 size="20" color="var(--primary-color)" />
    </components.DropdownIndicator>
  );
};

